import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";

import { t } from "@/i18n-js/instance";
import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { NavGroup } from "../NavGroup";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

// Exposes `isCommunityOnPlus` alongside the links so `PlansLinks` can render
// its title without a second `usePlanStatus()` call.
export const usePlansLinks = (): {
  isCommunityOnPlus: boolean;
  links: Link[];
} => {
  const { isCommunityOnPlus, isCommunityOnTrial } = usePlanStatus();
  const { currentCommunity } = usePunditUserContext();

  const links: Link[] = [
    {
      label: t("settings_nav_v3.plans.billing_history"),
      path: settingsNavPathV3.plans.billing,
      exact: true,
      isDisabled:
        isCommunityOnPlus || !currentCommunity?.has_subscription_record,
    },
    {
      label: isCommunityOnPlus
        ? t("settings_nav_v3.plans.billing_details")
        : t("settings_nav_v3.plans.change_plan"),
      path: settingsNavPathV3.plans.general,
      exact: true,
    },
    {
      label: t("settings_nav_v3.plans.branded_apps"),
      path: settingsNavPathV3.plans.brandedApps,
      exact: true,
      isDisabled: isCommunityOnPlus,
    },
    {
      label: t("settings_nav_v3.plans.payment_details"),
      path: settingsNavPathV3.plans.payment_details,
      exact: true,
      isDisabled: isCommunityOnTrial,
    },
    {
      label: t("settings_nav_v3.plans.invoices"),
      path: settingsNavPathV3.plans.invoices,
      exact: true,
      isDisabled: isCommunityOnTrial,
    },
  ];

  return { links, isCommunityOnPlus };
};

export const PlansLinks = () => {
  const { links, isCommunityOnPlus } = usePlansLinks();

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content
        title={
          isCommunityOnPlus
            ? t("settings_nav_v3.plans.plus_label")
            : t("settings_nav_v3.plans.label")
        }
      >
        {links.map(link => (
          <SubNavLinkItem
            key={link.path}
            label={link.label}
            to={link.path}
            isDisabled={link.isDisabled}
          />
        ))}
      </NavGroup.Content>
    </NavGroup>
  );
};
